import { render } from "./ModalModifierAuteur.vue?vue&type=template&id=2e5ef919&scoped=true"
import script from "./ModalModifierAuteur.vue?vue&type=script&lang=js"
export * from "./ModalModifierAuteur.vue?vue&type=script&lang=js"

import "./ModalModifierAuteur.vue?vue&type=style&index=0&id=2e5ef919&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e5ef919"]])

export default __exports__